import I18n from 'js/lib/i18n.js.erb'
;(function ($) {
  $(document).on('ajax:success', '.notification--body_container.listing_adopted .action', function () {
    $.petrescue.flash('notice', I18n.t('notifications.listing_adopted.flash.success'))
  })
})(jQuery)
